import { EValuationTabs } from '../../types/realtyValuation';

export const VALUATION_TABS = [
  /** Все комнатности **/
  {
    id: EValuationTabs.PriceDynamic,
    title: 'Динамика цен на квартиры',
  },
  {
    id: EValuationTabs.SellStatus,
    title: 'Распроданность квартир',
  },
];
